import React from 'react'

import { Button, Heading } from '@/components'

import './OralExam.scss'

const OralExamResults = ({ isPractice = false, onClickBack, results = [] }) => {
  return (
    <div className="oral-exam__results-wrapper">
      <div className="oral-exam__wrapper">
        <Heading is2>Exam Results</Heading>
        <div className="oral-exam__results">
          {results.map((item, index) => {
            const {
              learningObjectives: itemLearningObjectives,
              passed: itemHasPassed,
              question: itemQuestion,
              activity: itemActivity,
            } = item || {}
            return (
              <div
                className="oral-exam__results-item"
                key={`oral-exam__results-item-${index}`}
              >
                <Heading className="oral-exam__results-item-number" is3>
                  Question {index + 1}:
                </Heading>
                <div className="oral-exam__results-item-question">
                  <Heading
                    className="oral-exam__results-item-question-title"
                    dangerouslySetInnerHTML={{ __html: itemQuestion }}
                    is2
                  />
                  <div className="oral-exam__results-item-question-icon">
                    <span>
                      {itemHasPassed ? (
                        <i className="fa fa-check" />
                      ) : (
                        <i className="fa fa-close" />
                      )}
                    </span>
                  </div>
                </div>
                {itemLearningObjectives &&
                  itemLearningObjectives.length > 0 &&
                  !itemHasPassed && (
                    <div className="oral-exam__results-item-learning-objectives">
                      {itemLearningObjectives.map((lo, loIndex) => (
                        <p
                          className="oral-exam__results-item-learning-objective"
                          key={`oral-exam__results-item-lo-${loIndex}`}
                        >
                          * {lo}
                        </p>
                      ))}
                    </div>
                  )}
                {isPractice && itemActivity && itemActivity.goodToKnow && (
                  <div className="oral-exam__results-block">
                    <span className="oral-exam__results-item-feedback-label">
                      Feedback:
                    </span>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: itemActivity.goodToKnow,
                      }}
                    />
                  </div>
                )}
              </div>
            )
          })}
        </div>
        <div className="oral-exam__done-buttons">
          <Button isRounded onClick={onClickBack}>
            Back
          </Button>
        </div>
      </div>
    </div>
  )
}

export default OralExamResults
